<div class="container-fluid">
  <app-pagetitle title="Plant Mapping" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
  <div class="d-flex justify-content-end mb-2">
    <div class="example-button-row">
      <button class="btn btn-primary" title="Add" (click)="addSuperCustomer(content)">
        Add S_Customer
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive" *ngIf="superCustomerList.length > 0; else noData">
            <table class="table table-striped table-bordered mb-0">
              <thead class="table-dark">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile Number</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of superCustomerList">
                  <td>{{ customer.name }}</td>
                  <td>{{ customer.emailId }}</td>
                  <td>{{ customer.mobileNumber }}</td>
                  <td>
                    <i class="fas fa-edit text-primary font-size-18" (click)="editSuperCustomer(customer, content)"></i>
                    &nbsp;
                    <i class="fas fa-trash text-warning font-size-18"
                      (click)="deleteSuperCustomer(customer, deleteModal)"></i>

                  </td>

                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noData>
            <div class="text-center">
              <p>No super customer available</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ isEditMode ? 'Edit Super Customer' : 'Add Super Customer' }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="s_customerForm" (ngSubmit)="saveData()">
      <div class="form-group">
        <label for="name">Name</label>
        <input type="text" class="form-control" id="name" formControlName="name"
          [ngClass]="{ 'is-invalid': submitted && type.name.errors }" />
        <div *ngIf="submitted && type.name.errors" class="invalid-feedback">
          <div *ngIf="type.name.errors.required">Name is required</div>
        </div>
      </div>
      <div class="form-group">
        <label for="emailId">Email</label>
        <input type="email" class="form-control" id="emailId" formControlName="emailId"
          [ngClass]="{ 'is-invalid': submitted && type.emailId.errors }" [readonly]="isEditMode" />
        <div *ngIf="submitted && type.emailId.errors" class="invalid-feedback">
          <div *ngIf="type.emailId.errors.required">Email is required</div>
          <div *ngIf="type.emailId.errors.email">Email must be valid</div>
        </div>
      </div>
      <div class="form-group" *ngIf="!isEditMode">
        <label for="password">Password</label>
        <div class="input-group">
          <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password"
            formControlName="password" [ngClass]="{ 'is-invalid': submitted && type.password.errors }" />
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="togglePassword()">
              <i class="fa" [ngClass]="{'fa-eye-slash': !showPassword, 'fa-eye': showPassword}"></i>
            </button>
          </div>
          <div *ngIf="submitted && type.password.errors" class="invalid-feedback">
            <div *ngIf="type.password.errors.required">Password is required</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="mobileNumber">Mobile Number</label>
        <div class="input-group" [ngClass]="{ 'is-invalid': submitted && type.mobileNumber.errors }">
          <ngx-intl-tel-input [cssClass]="'form-control' + (submitted && type.mobileNumber.errors ? ' is-invalid' : '')"
            [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
            [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
            [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="PhoneNumberFormat.National"
            name="mobileNumber" formControlName="mobileNumber">
          </ngx-intl-tel-input>
          <div *ngIf="submitted && type.mobileNumber.errors" class="invalid-feedback d-block">
            <div *ngIf="type.mobileNumber.errors.required">Mobile Number is required</div>
            <div *ngIf="type.mobileNumber.errors.validatePhoneNumber">Invalid Mobile Number</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <h6>Available Plants</h6>
          <div class="card" dndDropzone (dndDrop)="onDrop($event, availableCustomers)">
            <div class="card-body scrollable-dropzone">
              <div class="list-group">
                <div class="list-group-item" *ngFor="let item of availableCustomers" [dndDraggable]="item"
                  (dndMoved)="onDragged(item, availableCustomers, 'move')" [dndEffectAllowed]="'move'">
                  {{ item.name }} ({{ item.custId }})
                </div>
                <div *ngIf="availableCustomers.length === 0" class="text-muted text-center p-2">
                  No customers available
                </div>
                <div class="dndPlaceholder" dndPlaceholderRef></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <h6>Selected Plants</h6>
          <div class="card" dndDropzone (dndDrop)="onDrop($event, selectedCustomers)">
            <div class="card-body scrollable-dropzone">
              <div class="list-group">
                <div class="list-group-item list-group-item-success" *ngFor="let item of selectedCustomers"
                  [dndDraggable]="item" (dndMoved)="onDragged(item, selectedCustomers, 'move')"
                  [dndEffectAllowed]="'move'">
                  {{ item.name }} ({{ item.custId }})
                </div>
                <div *ngIf="!selectedCustomers?.length" class="text-muted text-center p-2">
                  Drag customers here
                </div>
                <div class="dndPlaceholder" dndPlaceholderRef></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button type="submit" class="btn btn-primary"
          [disabled]="s_customerForm.invalid || (selectedCustomers?.length < 2)">
          {{ isEditMode ? 'Update' : 'Save' }}
        </button>
        <button type="button" class="btn btn-secondary ml-1" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Super Customer</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this super customer?</p>
    <div class="text-right">
      <button type="button" class="btn btn-danger" (click)="deleteSuperCustomerId(customerId)">Delete</button>
      <button type="button" class="btn btn-secondary ml-1" (click)="modal.dismiss('Cross click')">Cancel</button>
    </div>

  </div>
</ng-template>